

angular
.module('inkfinder')
.factory('StyleFactory', function StyleFactory(
  $q,
  $http,
  ENDPOINT,
  AlertMessages
) {
  StyleFactory.getStyles = getStyles;

/**
  * @description Get styles to provide in a select box for users to choose
  * @return {array?} Returns an array of styles?
  */
  function getStyles() {
    return $http.get(ENDPOINT.server + 'styles/api/v1.1/all/', {cache: true})
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return StyleFactory;
});



// WEBPACK FOOTER //
// ./components/styles/styles.service.js